/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import locale from '@glu/locale';
import Grid from '../Grid/Grid';
import ComposedView from '../ComposedView/ComposedView';

export default function ComposedGrid(props) {
  return (
    <ComposedView
      numberFilterTypes={[
        { text: locale.get('gridReact.equals'), value: 'equals' },
        { text: locale.get('gridReact.isLessThan'), value: 'lessThan' },
        { text: locale.get('gridReact.isGreaterThan'), value: 'greaterThan' }
      ]}
      {...props}
    >
      {(gridProps) => (
        <Grid
          headerHeight="40"
          target="screen"
          pagination
          {...gridProps}
        />
      )}
    </ComposedView>
  );
}
